import {useCallback} from 'react';
import {
    EventAction,
    EventCategory,
    EventCurrencyCodes,
    EventLabel,
    EventNames,
} from 'modules/google-analytics/constants';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {IAnalyticsMeta} from 'core/types';
import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';
import {getProductEcommerceData} from 'modules/product-card/analytics/gtag/helpers';
import {IProduct} from 'modules/product-card/models/ProductResponse';

export const useProductClickAnalytics = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        (product: Partial<IProduct>, analytics: IAnalyticsMeta = {}) =>
            () => {
                const dataLayerList = {
                    event: EventNames.OWOX,
                    eventCategory: EventCategory.Interactions,
                    eventAction: EventAction.Click,
                    eventLabel: EventLabel.Product,
                    eventLocation,
                    ecommerce: {
                        currencyCode: EventCurrencyCodes.RUB,
                        click: {
                            actionField: {
                                list: analytics.listName ?? eventLocation ?? undefined,
                            },
                            products: [
                                {
                                    position: analytics.positionIndex || 1,
                                    list: analytics.listName ?? eventLocation ?? undefined,
                                    ...getProductEcommerceData(product),
                                },
                            ],
                        },
                    },
                };

                sendGtagEvent(dataLayerList);
            },
        [eventLocation],
    );
};
